<template>
	<Tippy
		:content="$t('chat_message_edited_date', { Date: formattedDate })"
		class="edited"
	>
		{{ $t('chat_message_edited') }}
	</Tippy>
</template>

<script>
import { Tippy } from '@/components/common'
import { getLocalDate } from '@/helpers/utils'

export default {
	name: 'EditedFlag',
	components: { Tippy },
	props: ['date'],
	computed: {
		formattedDate() {
			return this.$m(getLocalDate(this.date)).format('l, LT')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.edited {
	@include fontFamily(800);
	font-size: 12px;
	color: $neutral-300;
}
</style>
